<template>
  <v-menu
    ref="fecha"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :readonly="readonly"
    :disabled="readonly"
  >
    <template v-slot:activator="{on}">
      <v-text-field
        :outlined="outlined"
        hide-details="auto"
        :rules="rules"
        v-on="on"
        :label="label"
        @change="fechaCambiada"
        slot="activator"
        :value="formatDate(fecha)"
        prepend-icon="event"
      ></v-text-field>
    </template>
    <v-date-picker
      :readonly="readonly"
      @change="change"
      @input="$refs.fecha.save(fecha)"
      locale="es-es"
      v-model="fecha"
      scrollable
      :min="min"
      :max="max"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'datepicker',
  props: ['readonly', 'value', 'label', 'rules', 'max', 'min', 'outlined'],
  data() {
    return {
      fecha: {},
    };
  },
  created() {
    this.fecha = this.value;
  },
  watch: {
    fecha() {
      if (this.fecha) {
        const [year, month, day] = this.fecha.split('-');
        this.$emit('input', `${day}/${month}/${year}`);
      } else {
        this.$emit('input', null);
      }
    },
    value() {
      this.fecha = this.value;
    },
  },
  methods: {
    change() {
      this.$emit('change');
    },
    fechaCambiada(val) {
      try {
        const parts = val.split('/');
        const fecha = new Date(parts[2], parseInt(parts[1]) - 1, parts[0]);
        if (!!this.min && fecha < new Date(this.min)) {
          this.fecha = '';
          return;
        }
        if (!!this.max && fecha > new Date(this.max)) {
          this.fecha = '';
          return;
        }
        this.fecha = this.fechaPicker(fecha);
      } catch {
        this.fecha = '';
      }
    },
  },
  computed: {},
};
</script>

<style></style>
